export const ERR_NAMES = {
    too_many_requests: 'TooManyRequests',
    forbidden: 'Forbidden',
    not_authenticated: 'NotAuthenticated'
}